export enum Ethnicity {
  nzEuropean = 'NZ European',
  maori = 'Māori',
  pacific = 'Pacific',
  asian = 'Asian',
  middleEastern = 'Middle Eastern/Latin American/African',
  other = 'Other',
}
